import { PatientRegistrationRequest } from "src/models/patientRegisterationRequest";
import { ApiService } from "../apiService";
import { LoginResponse } from "src/models/loginResponse";
import { generateotprequest, GenerateOtpResponse, ValidateOtpRequest } from "src/models/generateotp";
import { ApiResponse } from "../apiType";
import { ResetPasswordByUserRequest } from "src/models/resetpassword";


const apiService = new ApiService();

export const generateOTP = async (
  getotpDetails: generateotprequest
): Promise<ApiResponse<GenerateOtpResponse>> => {
  return apiService.post("Home/GenerateOTP", getotpDetails);
};


export const validateOtp = async (
  otpDetails: ValidateOtpRequest
): Promise<ApiResponse<boolean>> => {
  return apiService.post("Home/validate-otp", otpDetails); // adjust endpoint if needed
};

export const registerPatient = async (patientDetails:PatientRegistrationRequest) => apiService.post(`Home/CreatePatient`, patientDetails);

export const registerDoctor = async (doctorDetails:FormData) => apiService.post(`Home/CreateDoctor`, doctorDetails, {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
});

export const login = async (emailAddress:string, password:string) => apiService.post<LoginResponse>(`account/Auth/Login`, {emailAddress, password});

export const checkEmailExists = (email: string) =>apiService.get<boolean>(`Home/CheckEmailExists?email=${encodeURIComponent(email)}`);

export const sendResetPasswordEmail = async (emailAddress: string) => apiService.post(`account/Auth/forgot-password`, {emailAddress});

export const resetPassword = async (token: string, newPassword: string) =>  apiService.post(`account/Auth/reset-password`, { token, newPassword });
 
export const checkPatientExists = async (
  email: string,
  firstName: string,
  lastName: string,
  dob: string
): Promise<ApiResponse<boolean>> => {
  const query = `Home/CheckPatientExists?email=${encodeURIComponent(email)}&firstname=${encodeURIComponent(firstName)}&lastname=${encodeURIComponent(lastName)}&dob=${encodeURIComponent(dob)}`;

  return apiService.get<boolean>(query);
};

export const validateConsultantAndGetMediRecordId = async (
  consultantDetails: any
): Promise<ApiResponse<string>> => {
  return apiService.post("Home/ValidateConsultant", consultantDetails);
};

export const resetPasswordByUser = async (
  model: ResetPasswordByUserRequest
): Promise<ApiResponse<string>> => {
  return apiService.post("account/Auth/reset-password-by-user", model);
};


